var map = {
	"./auto_topup_registrations.svg": "6622",
	"./barring_factoring_status.svg": "7cc8",
	"./barring_pin_protection.svg": "ffe5",
	"./barring_reselling_status.svg": "2e1f",
	"./content_bundles.svg": "0ec8",
	"./internal_catalogue.svg": "90dc",
	"./internal_stock.svg": "4798",
	"./order_overview.svg": "ed16",
	"./payment_generation.svg": "f191",
	"./payment_transactions.svg": "2176",
	"./persistent_confirmations.svg": "64dd",
	"./product_catalogue.svg": "8a15",
	"./recharge_transactions.svg": "19ab",
	"./stock.svg": "3c32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c89";